<template>
  <div class="pageContent">
    <DxPopup v-model:visible="detailsVisible" :drag-enabled="false" :hide-on-outside-click="true"
      :show-close-button="true" :show-title="true" :width="800" :height="600" content-template="tank-info"
      titleTemplate="title">
      <!-- :title="this.getContainerHeader()" -->
      <template #title>
        <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%;">
          <div style="flex-grow: 1;">
            <h4>{{ title }}</h4>
            <div
              style="white-space: pre-line; margin-left:2em; font-weight: 100; font-size: 13px; padding-bottom: 5px;">
              {{ subtitle }}
            </div>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 8px;">
            <DxButton icon="chevronleft" type="default" styling-mode="text" :disabled="!canNavigatePrevious"
              @click="navigatePrevious" hint="Previous Record" />
            <DxButton icon="chevronright" type="default" styling-mode="text" :disabled="!canNavigateNext"
              @click="navigateNext" hint="Next Record" />
          </div>
        </div>
      </template>
      <template #tank-info>
        <R3ContainerDetails :containerId="selectedContainer" :container="fullContainer" :isOperator="isOperator"
          :isPopupOpen="this.detailsVisible" />
      </template>
    </DxPopup>
  </div>

</template>

<script>

// import R3ContainerDetails from "./container-details-v2.vue";
import R3ContainerDetails from "@/components/container/container-details.vue";
import { DxPopup } from 'devextreme-vue/popup';
import { DxButton } from 'devextreme-vue/button';

export default {
  props: ['containerId', 'isOperator'],
  components: {
    R3ContainerDetails,
    DxPopup,
    DxButton
  },
  created() {
    this.loadPageData();
  },
  mounted() {
    window.addEventListener('resize', this.setDimensions);
    this.setDimensions();
  },
  unmounted() {
    window.removeEventListener('resize', this.setDimensions);
  },
  watch: {
    containerId: function (newId, oldId) {
      // console.log("WATCH ID CHANGED", newId)

      // if(newId.toString().substring(0,1)=='-')
      if (newId < 0)
        newId = newId * -1
      if (newId != 0)
        this.openDetails(newId);
    }
  },
  data() {
    return {
      selectedContainer: 0,
      fullContainer: 0,
      detailsVisible: false,
      typeId: 1,
      currentRecordIndex: -1,
      // filteredContainers: [],
    };
  },
  computed: {
    canNavigatePrevious() {
      return this.currentRecordIndex > 0;
    },
    canNavigateNext() {
      return this.currentRecordIndex < this.filteredContainers.length - 1;
    },
    title() {
      let header = this.fullContainer.containerName;
      if (header == undefined || header == null) {
        return '-';
      }
      return header;
    },
    subtitle() {
      const headerprops = this.$store.getters["properties/getHeaderProperties"];

      var st = "";
      for (let i = 0; i < headerprops.length; i++) {
        st += headerprops[i].propertyName + ': ' + this.fullContainer[headerprops[i].propertyName] + '\n';
      }

      return st;
    },
    filteredContainers() {
      return this.$store.getters["containers/getContainersFilteredIds"]
    },
  },
  methods: {
    async openDetails(key) {
      this.currentRecordIndex = this.filteredContainers.findIndex(c => c === key);

      await this.$store.dispatch("containers/loadContainerStatus", key);
      this.fullContainer = this.$store.getters["containers/getContainerStatus"];
      // moved up to the parent screen/obj so it doesn't keep calling every time we click on a row in grid
      // await this.$store.dispatch("properties/loadProperties");

      this.selectedContainer = key;
      this.detailsVisible = true;
    },
    navigatePrevious() {
      if (this.canNavigatePrevious) {
        // console.log("current index", this.currentRecordIndex)
        this.currentRecordIndex--;
        this.navigate()
      }
    },
    navigateNext() {
      if (this.canNavigateNext) {
        // console.log("current index", this.currentRecordIndex)
        this.currentRecordIndex++;
        this.navigate()
      }
    },
    async navigate(key) {
      // console.log("open index", this.currentRecordIndex)
      // console.log("open key", this.filteredContainers[this.currentRecordIndex])
      await this.$store.dispatch("containers/loadContainerStatus", this.filteredContainers[this.currentRecordIndex]);
      this.selectedContainer = this.filteredContainers[this.currentRecordIndex];
      this.fullContainer = this.$store.getters["containers/getContainerStatus"];
    },
    setDimensions() {
      const h = document.documentElement.clientHeight;
      this.datagridHeight = (h - 215) + 'px';
    },
    async loadPageData() {

    },
  },
};

</script>

<style scoped>
/* .pageContent {
  max-height: 40vh;
  overflow: scroll;
} */

.ph {
  /* page header */
  height: 50px;
}

img {
  width: 80px;
  height: 80px;
}

p {
  text-align: left;
  margin-left: 4em;
  margin-top: 0em;
  font-weight: 300;
}

h6 {
  text-align: left;
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 0em;
  margin-left: 2.5em;
  font-weight: 300;
}

h4 {
  font-size: 26px;
  font-weight: 200;
  text-align: left;
  margin-top: 0.5em;
  margin-bottom: 0em;
  margin-left: 1em;
}

.prop {
  margin: 10px 60px 0 60px;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: red;
  color: white;
  text-align: center;
}

.mininote {
  text-align: left;
  font-size: 11px;
  /* margin-top:8px; */
  /* margin-bottom:0em; */
  /* margin-left:2.5em;  */
  font-weight: 300;
  color: rgb(255, 125, 0);
}

.subtitle pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: inherit;
}
</style>
